import { render, staticRenderFns } from "./ConnectedRadioHeader.vue?vue&type=template&id=222a155a&scoped=true&"
var script = {}
import style0 from "./ConnectedRadioHeader.vue?vue&type=style&index=0&id=222a155a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a155a",
  null
  
)

export default component.exports